import * as Yup from 'yup';
import { t } from 'src/lib/language';
import { idFieldRequired, moneyField } from 'src/lib/ValidatorHelper';
/* eslint-disable import/no-extraneous-dependencies */

const InvoiceOrderValidator = (
  orders: any, lang:string, ticketFieldsByRow?: Record<number, string[]>,
) => {
  const orderValidator = {};

  orders.forEach((order: any, index: number) => {
    orderValidator[`deductible_${index}`] = Yup.number()
      .min(0)
      .max(100)
      .nullable();
    orderValidator[`discount_${index}`] = moneyField()
      .nullable();
    orderValidator[`note_${index}`] = Yup.string()
      .max(500)
      .nullable();
    orderValidator[`paid_${index}`] = moneyField();
    orderValidator[`product_id_${index}`] = idFieldRequired()
      .required(t(lang, 'validations.invoice.field_required'));
    orderValidator[`quantity_${index}`] = Yup.number()
      .positive()
      .required();
    if (ticketFieldsByRow?.[index] && ticketFieldsByRow[index].length > 0) {
      const ticketShape: Record<string, Yup.StringSchema> = {};
      ticketFieldsByRow[index].forEach((field) => {
        ticketShape[field] = Yup.string().required(t(lang, 'validations.invoice.field_required'));
      });
      orderValidator[`tickets_${index}`] = Yup.array().of(Yup.object().shape(ticketShape));
    }
  });

  return Yup.object().shape(orderValidator);
};

export default InvoiceOrderValidator;
